export default __webpack_public_path__ + "static/media/circle-icon.ff1969dd.svg";